export default __webpack_public_path__ + "static/HomePageThumbnail-78410ab214456d586b1a177bf39d88cc.jpg";